/* Grondyke · Founder video: swaps the poster for the video on play. */
(function () {
  function init(media) {
    if (media.dataset.gkReady) return;
    media.dataset.gkReady = '1';
    var btn = media.querySelector('[data-gk-founder-play]');
    var tpl = media.querySelector('template[data-gk-founder-video]');
    if (!btn || !tpl) return;
    btn.addEventListener('click', function () {
      var node = tpl.content.cloneNode(true);
      media.appendChild(node);
      media.classList.add('is-playing');
      var v = media.querySelector('video');
      if (v && typeof v.play === 'function') { try { v.play(); } catch (e) {} }
    });
  }
  function boot() {
    var list = document.querySelectorAll('[data-gk-founder-media]');
    for (var i = 0; i < list.length; i++) init(list[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
